import { Box } from "@jewlr/storybook/core"
import PropTypes from "prop-types"
import { useSelector } from "react-redux"
import { useLocation } from "react-router-dom"
import styled from "styled-components"

import { isTestMode } from "helpers/application"

import Textarea from "../textarea"

import FeatureGridItem from "./item"

// Keep these styles in sync with the loading shimmer `areas/landing/loaders/feature-grid.jsx`

export const Container = styled(Box).attrs((props) => ({
  display: "grid",
  gridGap: { _: 1, tablet: 2, widescreen: 5 },
  gridTemplateColumns: {
    _: "repeat(2, 1fr)",
    tablet: "repeat(4, 1fr)",
  },
  px: { _: 2, tablet: 4, widescreen: "60px" },
  py: { _: "6px", tablet: "12px" },
  ...props,
}))``

const FeatureGrid = ({ element, lazyload }) => {
  const eventName = element.event_name
  const homepageExp = useSelector(
    (state) => state.experiment.homepage.variant_id
  )
  const { pathname } = useLocation()
  const isHomepage = pathname === "/"

  const handleClick = (title, url) => {
    if (eventName && !isTestMode) {
      dataLayer.push({
        clickedUrl: url,
        element: title,
        event: eventName,
      })
    }
  }

  return (
    <Box {...element.style?.block_style}>
      {element.textarea && (
        <Textarea
          element={element.textarea}
          linkClickData={element.anchor_name || element.id}
          style={element.textarea.style}
        />
      )}
      <Container containWide={element.contain} {...element.container_style}>
        {(element.data?.items || []).map((item, index) => (
          <FeatureGridItem
            element={element}
            homepageExp={homepageExp === 1 && isHomepage}
            item={item}
            key={`${element.id}-${index}`}
            lazyload={lazyload}
            onItemClick={() => handleClick(item.title, item.url)}
          />
        ))}
      </Container>
    </Box>
  )
}

FeatureGrid.propTypes = {
  element: PropTypes.object,
  lazyload: PropTypes.bool,
}

export default FeatureGrid
